export default __webpack_public_path__ + "static/media/hero.f7d3379b.png";